import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Cut-down version of ChallengeModal for joining an open battle lobby (see
 * ArenaBattleOpenPost) — no opponent to pick (it's already this battle's
 * challenger), just the joiner's own ready deck.
 */
export default class JoinBattleModal extends Modal {
  error = null;
  loading = false;
  loadingDecks = true;
  readyDeckSlots = [];
  selectedDeckSlotId = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadDeckSlots();
  }
  async loadDeckSlots() {
    this.loadingDecks = true;
    m.redraw();
    try {
      const response = await app.request({
        method: 'GET',
        url: `${app.forum.attribute('apiUrl')}/arena/deck-slots`
      });
      const slots = response?.slots ?? [];
      this.readyDeckSlots = slots.filter(s => s.cardCount === 20);
      this.selectedDeckSlotId = this.readyDeckSlots[0]?.id ?? null;
    } catch {
      this.readyDeckSlots = [];
      this.selectedDeckSlotId = null;
    } finally {
      this.loadingDecks = false;
      m.redraw();
    }
  }
  className() {
    return 'ArenaChallengeModal ArenaJoinBattleModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-user-plus"
    }), " ", app.translator.trans('forumaker-arena.forum.join_modal.title'));
  }
  content() {
    const hasDeck = !this.loadingDecks && this.readyDeckSlots.length > 0;
    // random_cards: same reasoning as SelectBattleDeckModal's isRandomCards —
    // the lobby creator's modifier choice already decided every card in
    // play, so the usual "ready to fight {name}?" copy is replaced with the
    // same explanation used there instead of implying a deck pick matters.
    const isRandomCards = this.attrs.modifier === 'random_cards';
    return m("div", {
      className: "Modal-body"
    }, this.error && m("div", {
      className: "Alert Alert--error",
      style: {
        marginBottom: '12px'
      }
    }, m("i", {
      className: "fas fa-exclamation-circle"
    }), " ", this.error), m("p", null, isRandomCards ? app.translator.trans('forumaker-arena.forum.select_deck_modal.text_random_cards') : app.translator.trans('forumaker-arena.forum.join_modal.text', {
      name: m("strong", null, this.attrs.challengerName)
    })), !this.loadingDecks && !hasDeck && m("div", {
      className: "Alert Alert--warning",
      style: {
        marginBottom: '12px'
      }
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), ' ', app.translator.trans('forumaker-arena.forum.challenge_modal.no_deck'), ' ', m("a", {
      className: "ArenaChallengeModal-buildDeckLink",
      href: "#",
      onclick: e => {
        e.preventDefault();
        this.hide();
        m.route.set(app.route('user.arena', {
          username: app.session.user?.username() ?? ''
        }));
      }
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.build_deck'))), hasDeck && !isRandomCards && m("div", {
      className: "Form-group ArenaChallengeModal-deckWrap"
    }, m("label", null, app.translator.trans('forumaker-arena.forum.challenge_modal.deck_label')), m("select", {
      className: "FormControl",
      value: this.selectedDeckSlotId ?? '',
      onchange: e => {
        this.selectedDeckSlotId = parseInt(e.target.value, 10);
      }
    }, this.readyDeckSlots.map(slot => m("option", {
      key: slot.id,
      value: slot.id
    }, slot.name)))), m("div", {
      className: "Form-group ArenaChallengeModal-submitGroup"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      loading: this.loading,
      disabled: !hasDeck || this.selectedDeckSlotId == null || this.loading,
      onclick: () => this.submit()
    }, isRandomCards ? app.translator.trans('forumaker-arena.forum.select_deck_modal.start_btn') : m('[', null, m("i", {
      className: "fas fa-user-plus"
    }), " ", app.translator.trans('forumaker-arena.forum.join_modal.submit')))));
  }
  async submit() {
    if (this.selectedDeckSlotId == null) return;
    this.loading = true;
    this.error = null;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/arena/battles/${this.attrs.battleId}/join`,
        body: {
          deckSlotId: this.selectedDeckSlotId
        },
        errorHandler: () => {} // see ArenaProfilePage.tsx saveDeck() — this.error already renders its own inline banner
      });
      this.hide();
      // A full reload guarantees the session user's arenaActiveBattles
      // attribute, the discussion, and its posts are all freshly fetched —
      // simpler and more reliable than trying to patch every piece of local
      // state the card slider/deck-lock UI depends on (see addCardSlider.tsx).
      window.location.reload();
    } catch (e) {
      const body = e?.response ?? e?.response?.body ?? e?.responseJSON ?? {};
      this.error = body?.error ?? body?.errors?.[0]?.detail ?? app.translator.trans('forumaker-arena.forum.join_modal.error_generic');
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/JoinBattleModal', JoinBattleModal);